import { Controller } from "@hotwired/stimulus"
import { Modal } from 'bootstrap'

export default class extends Controller {
  static values = {
    url: String
  }

  async open(event) {
    event.preventDefault()

    const modal = document.getElementById('addToCartModal')
    const frame = document.getElementById('add_to_cart_modal_content')

    // Show loading state
    frame.innerHTML = `
      <div class="modal-body text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    `

    // Open modal
    const bsModal = new Modal(modal)
    bsModal.show()

    // Load content
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        frame.innerHTML = html

        // Execute any inline scripts in the loaded content
        const scripts = frame.querySelectorAll('script')
        scripts.forEach(script => {
          const newScript = document.createElement('script')
          newScript.textContent = script.textContent
          script.parentNode.replaceChild(newScript, script)
        })
      }
    } catch (error) {
      console.error('Error loading modal content:', error)
      frame.innerHTML = `
        <div class="modal-body text-center py-5 text-danger">
          Fehler beim Laden
        </div>
      `
    }
  }
}

